import { z } from 'zod'
import { Timestamp } from './common.js'

export const ProposalStatus = z.enum([
  'open',
  'approved',
  'rejected',
  'stale',
  'expired',
  'withdrawn',
])
export type ProposalStatus = z.infer<typeof ProposalStatus>

export const ProposalDoc = z.object({
  id: z.string().uuid(),
  pk: z.string(), // = route_id partition key
  route_id: z.string().uuid(),
  author_id: z.string().uuid(),
  base_etag: z.string(),
  changes: z.record(z.unknown()),
  staged_cleanup_paths: z.array(z.string()).optional(),
  message: z.string().max(500).optional(),
  status: ProposalStatus,
  reviewer_id: z.string().uuid().optional(),
  review_note: z.string().max(500).optional(),
  created_at: Timestamp,
  resolved_at: Timestamp.optional(),
})
export type ProposalDoc = z.infer<typeof ProposalDoc>

export const ProposalPublic = ProposalDoc.omit({ pk: true, staged_cleanup_paths: true })
export type ProposalPublic = z.infer<typeof ProposalPublic>

export const ProposalCreateRequest = z.object({
  changes: z.record(z.unknown()),
  base_etag: z.string(),
  message: z.string().max(500).optional(),
})
export type ProposalCreateRequest = z.infer<typeof ProposalCreateRequest>

export const ProposalRejectRequest = z.object({
  note: z.string().max(500).optional(),
})
export type ProposalRejectRequest = z.infer<typeof ProposalRejectRequest>

export function proposalToPublic(doc: ProposalDoc): ProposalPublic {
  const { pk: _, staged_cleanup_paths: _cleanup, ...rest } = doc
  return rest
}
